import React, { useState } from "react";
import { useToast } from "../../../hooks/use-toast";
import { DrugNotCoveredAxiosInstance } from "../../../Network/DrugNotCoveredAxiosInstance";
interface FileUploadProps {
  fetchItems?: () => Promise<void>; // Add fetchItems as an optional prop
}

const FileUpload: React.FC<FileUploadProps> = ({ fetchItems }) => {
  const [file, setFile] = useState<File | null>(null);

  // Initialize toast
  const { toast } = useToast();
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  const handleUpload = async () => {
    if (!file) {
      toast({
        title: "Error",
        description: "Please select a file to upload",
        variant: "destructive",
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      
       const { data } = await DrugNotCoveredAxiosInstance.post("uploadFile", formData);
      const { success, message, errors } = data;

      if (success) {
        toast({
          title: "Success",
          description: message || "File uploaded successfully.",
        });

        // Call fetchItems after success
        if (fetchItems) {
          await fetchItems();
        }
        if (errors && errors.length > 0) {
          const errorMessage = errors.join("\n");
          toast({
            title: "Errors Detected",
            description: errorMessage,
            variant: "destructive",
          });
        }
      } else {
        toast({
          title: "Failed to Upload File",
          description: message || "Failed to upload file",
          variant: "destructive",
        });
      }

    } catch (error) {
      toast({
        title: "Error",
        description: (error as any)?.response?.data?.error || "Failed to upload file",
        variant: "destructive",
      });
      console.error(error);
    }
  };

  return (
    <div className="container" style={{ margin: "30px" }}>
      <h5></h5>
      <div className="row">
        <div className="input-group w-50 m-3">
          <input
            type="file"
            className="form-control"
            onChange={handleFileChange}
          />
          <button
            className="btn btn-secondary"
            onClick={handleUpload}
            style={{
              marginLeft: "10px",
              padding: "8px",
              backgroundColor: "#007bff",
            }}
          >
            <span className="m-1">
              <i className="fa-solid fa-upload"></i>
            </span>
            Upload
          </button>
        </div>
      </div>
    </div>
  );
};

export default FileUpload;
